import { useClientApplicationQuery } from "@graphql/client-applications/ClientApplications.g";
import { RouteObject, UIMatch, redirect } from "react-router";

import { queryClient } from "@api/queries";

import { CurrentClientName } from "@components/Texts";

import { PortalPage } from "@layouts/PortalPage/PortalPage.layout";
import { ExtensionInstallationGuard } from "@components/RouteGuards/ExtensionInstallationGuard/ExtensionInstallationGuard";

import { routes } from "@pages/routes";

import { Application } from "./Application/Application.page";
import { ApplicationDashboard } from "./ApplicationDashboard/ApplicationDashboard.page";
import { ApplicationRecord } from "./ApplicationRecord/ApplicationRecord.page";
import { ApplicationUsers } from "./ApplicationUsers/ApplicationUsers.page";
import { Applications } from "./Applications/Applications.page";

export const applicationRoutes = [
  {
    path: routes.portal.clients.client.applications.index.$path(),
    Component: PortalPage,
    handle: {
      breadcrumb: {
        reset: true,
        left: <CurrentClientName />,
        title: "Applications",
      },
    },
    children: [
      {
        Component: ExtensionInstallationGuard,
        children: [
          {
            index: true,
            Component: Applications,
          },
          {
            path: routes.portal.clients.client.applications.application.$path(),
            Component: Application,
            handle: {
              breadcrumb: async ({
                params: { applicationId = "", clientId = "" },
              }: UIMatch) => {
                // applicationId is the client application ID
                const data = await queryClient.fetchQuery({
                  queryKey: useClientApplicationQuery.getKey({
                    clientId,
                    clientApplicationId: applicationId,
                  }),
                  queryFn: useClientApplicationQuery.fetcher({
                    clientId,
                    clientApplicationId: applicationId,
                  }),
                });

                // Get the resource product name
                const productName = data?.clientApplication?.resource?.productName;

                return {
                  title: productName,
                };
              },
            },
            children: [
              {
                index: true,
                loader: ({ params: { applicationId = "", clientId = "" } }) => {
                  return redirect(
                    routes.portal.clients.client.applications.application.dashboard.$buildPath(
                      {
                        params: { clientId, applicationId },
                      },
                    ),
                  );
                },
              },
              {
                path: routes.portal.clients.client.applications.application.dashboard.$path(),
                Component: ApplicationDashboard,
                handle: {
                  breadcrumb: {
                    title: "Dashboard",
                  },
                },
              },
              {
                path: routes.portal.clients.client.applications.application.record.$path(),
                Component: ApplicationRecord,
                handle: {
                  breadcrumb: {
                    title: "Record",
                  },
                },
              },
              {
                path: routes.portal.clients.client.applications.application.users.$path(),
                Component: ApplicationUsers,
                handle: {
                  breadcrumb: {
                    title: "Users",
                  },
                },
              },
            ],
          },
        ],
      },
    ],
  },
] satisfies RouteObject[];
